// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"71d824dd","546":"a061c166"}[chunkId] + ".chunk.js";
};